import { motion } from "framer-motion";
import {
  Boxes,
  ShieldCheck,
  Hammer,
  Settings2,
  Building2,
  MapPin,
} from "lucide-react";
import { FEATURES } from "@/data/content";
import HammersBackdrop from "@/components/site/HammersBackdrop";

const ICONS = { Boxes, ShieldCheck, Hammer, Settings2, Building2, MapPin };

export default function WhyChoose() {
  return (
    <section
      className="relative bg-paper-alt py-24 md:py-32 overflow-hidden"
      data-testid="why-choose-section"
    >
      <HammersBackdrop density="light" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 relative z-10">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#16a34a]">
            Why Choose Us
          </div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#1c1917] mt-2 tracking-tight">
            Reliable people.{" "}
            <span className="text-[#57534e]">Real workmanship.</span>
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon] || Hammer;
            return (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="bg-white border border-[#e7e5df] rounded-3xl p-7 hover:-translate-y-1 hover:border-[#16a34a] hover:shadow-md transition-all duration-300"
                data-testid={`feature-${f.icon.toLowerCase()}`}
              >
                <div className="h-12 w-12 rounded-2xl bg-[#16a34a]/10 inline-flex items-center justify-center text-[#16a34a]">
                  <Icon className="w-6 h-6" strokeWidth={2.2} />
                </div>
                <h3 className="font-display font-bold text-xl text-[#1c1917] mt-4 tracking-tight">
                  {f.title}
                </h3>
                <p className="mt-2 text-[#57534e] text-sm leading-relaxed">
                  {f.body}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
